import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle('height:' + _ctx.height),
    "element-loading-text": "正在加载页面，请稍候！"
  }, [
    _createElementVNode("iframe", {
      id: _ctx.iframeId,
      style: {"width":"100%","height":"100%"},
      src: _ctx.src,
      frameborder: "no"
    }, null, 8, _hoisted_1)
  ], 4)), [
    [_directive_loading, _ctx.loading]
  ])
}